import React from "react";
import { Chip } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import EditNoteIcon from "@mui/icons-material/EditNote";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useTranslation } from "react-i18next";

// translationKey matches the i18n keys added for this feature: MissingData / Updated / Ready
export const STATUS_CONFIG = {
  conflict: {
    translationKey: "ContactInUse",
    color: "error",
    icon: <ErrorOutlineIcon fontSize="small" />,
  },
  missing: {
    translationKey: "MissingData",
    color: "warning",
    icon: <WarningAmberIcon fontSize="small" />,
  },
  updated: {
    translationKey: "Updated",
    color: "info",
    icon: <EditNoteIcon fontSize="small" />,
  },
  ready: {
    translationKey: "Ready",
    color: "success",
    icon: <CheckCircleOutlineIcon fontSize="small" />,
  },
};

/**
 * @param {{ status: "conflict" | "missing" | "updated" | "ready", count?: number, variant?: "filled" | "outlined" }} props
 */
export default function ImportStatusChip({ status, count, variant }) {
  const { t } = useTranslation();
  const config = STATUS_CONFIG[status];
  if (!config) return null;

  const label = t(config.translationKey);

  return (
    <Chip
      size="small"
      color={config.color}
      icon={config.icon}
      label={count === undefined ? label : `${label}: ${count}`}
      variant={variant ?? (count === undefined ? "filled" : "outlined")}
    />
  );
}
